import { render, staticRenderFns } from "./CashDepositCard.vue?vue&type=template&id=1310d916&scoped=true&"
import script from "./CashDepositCard.vue?vue&type=script&lang=js&"
export * from "./CashDepositCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1310d916",
  null
  
)

export default component.exports